export const SENIOR = 0;
export const JUNIOR = null;



// WEBPACK FOOTER //
// ./src/const/Auth.js